import React, { useState } from "react";
import PropTypes from "prop-types";

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNavigation = (direction) => {
    setCurrentIndex((prevIndex) => {
      if (direction === "prev") {
        return prevIndex === 0 ? images.length - 1 : prevIndex - 1;
      } else if (direction === "next") {
        return prevIndex === images.length - 1 ? 0 : prevIndex + 1;
      }
      return prevIndex;
    });
  };

  return (
    <div className="imgSlider">
      <div className="btnBox">
        <button
          className="prev_btn"
          onClick={() => handleNavigation("prev")}
        ></button>
        <button
          className="next_btn"
          onClick={() => handleNavigation("next")}
        ></button>
      </div>
      <div className="sliderImgBox">
        <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} />
      </div>
    </div>
  );
};

// ImageSlider.propTypes = {
//   images: PropTypes.arrayOf(PropTypes.string).isRequired, // 이미지 배열 필수
// };

export default ImageSlider;
